<script lang="ts" setup>
import { ref, inject } from 'vue';
import axiosApiClient from '@/axios';
import { useI18n } from 'vue-i18n';

const t = useI18n().t;
const swal: any = inject('$swal');
interface Partner {
    id: number;
    name: string;
    description: string;
    thumbnail: string;
}
const partners = ref<Partner[]>();
const partner = ref<Partner>({
    id: 0,
    name: '',
    description: '',
    thumbnail: '',
});
const getPartners = async () => {
    const { data } = await axiosApiClient.get('/api/partners');
    partners.value = data;
}
getPartners();

const deletePartner = async (id: number) => {
    const result = await swal.fire({
        title: t('Are you sure?'),
        text: t('You won\'t be able to revert this!'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('Yes, delete it!')
    });
    if (result.isConfirmed) {
        axiosApiClient.delete('/api/partners/' + id).then((res: any) => {
            console.log(res);
            if (res.status != '200') {
                swal.fire({
                    icon: 'error',
                    title: 'Something error'
                });
                return;
            }
            swal.fire(
                t('Deleted!'),
                t('Your partner has been deleted.'),
                'success'
            );
            getPartners();
        });
    }
}
const savePartner = async () => {
    const formData = new FormData();
    formData.append('name', partner.value.name);
    formData.append('description', partner.value.description);
    formData.append('status', 'active');

    //save files[0] as base64 string in the database
    var file = document.getElementById('partner_thumbnail') as HTMLInputElement;
    //check file size
    if (file.files && file.files[0] && file.files[0].size > 1024 * 1024) {
        swal.fire(
            t('Error!'),
            t('File size must be less than 1MB.'),
            'error'
        );
    }
    if (file.files && file.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(file.files[0]);
        reader.onload = async () => {
            const base64String = reader.result as string;
            formData.append('thumbnail', base64String.split(',')[1]);
            try {
                axiosApiClient.post('/api/partners', formData).then((res: any) => {
                    console.log(res);
                    if (res.status != '201') {
                        swal.fire(
                            t('Error!'),
                            t('Something went wrong.'),
                            'error'
                        );
                        return;
                    }
                    swal.fire(
                        t('Saved!'),
                        t('Your partner has been saved.'),
                        'success'
                    );
                    getPartners();
                });
            }
            catch (error) {
                console.log(error);
                swal.fire(
                    t('Error!'),
                    t('Something went wrong.'),
                    'error'
                );
            }
        }
    }
}
</script>
<template>
    <admin-layout>
        <div class="flex flex-col">
            <h3>{{ $localeT('Partners') }}</h3>
            <div class="flex flex-col justify-start p-2">
                <!--new form-->
                <label for="">{{ $localeT('New Partner') }}</label>
                <form class="flex flex-col gap-2 border p-2 rounded-md" @submit.prevent="savePartner">
                    <div class="flex flex-col">
                        <label for="name">{{ $localeT('Name') }}</label>
                        <input type="text" id="name" v-model="partner.name" class="form-control">
                    </div>
                    <div class="flex flex-col">
                        <label for="description">{{ $localeT('Description') }}</label>
                        <input type="text" id="description" v-model="partner.description" class="form-control">
                    </div>
                    <div class="flex flex-col">
                        <label for="thumbnail">{{ $localeT('Thumbnail') }}</label>
                        <input type="file" id="partner_thumbnail" class="form-control">
                    </div>
                    <div>
                        <button type="submit" class="btn btn-primary flex gap-2 items-center"><i class="fa fa-save mx-2"
                                :title="$localeT('Save')">
                            </i>{{ $localeT('Save') }}</button>
                    </div>
                </form>
            </div>
            <div>
                <!--list of-->
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $localeT('Name') }}</th>
                            <th>{{ $localeT('Description') }}</th>
                            <th>{{ $localeT('Thumbnail') }}</th>
                            <th>{{ $localeT('Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="partner in partners" :key="partner.id">
                            <td>{{ partner.name }}</td>
                            <td>{{ partner.description }}</td>
                            <td><img :src="'data:image/png;base64,' + partner.thumbnail" :alt="partner.description"
                                    width="150" height="150"></td>
                            <td>
                                <button class="btn btn-danger flex gap-2" @click="deletePartner(partner.id)"><i
                                        class="fa fa-trash mx-2" :title="$localeT('Delete')"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </admin-layout>
</template>



<style lang="scss" scoped></style>